var NAMESPACE = "https://lendi";
export var IDENTITY_TOKEN_USER_ID_KEY = "".concat(NAMESPACE, "/userId");
export var IDENTITY_TOKEN_ROLE_KEY = "".concat(NAMESPACE, "/userRole");
export var IDENTITY_TOKEN_PROFILE_KEY = "".concat(NAMESPACE, "/userProfile");
export var IDENTITY_TOKEN_EXISTING_KEY = "".concat(NAMESPACE, "/existingUser");
export var IDENTITY_TOKEN_AUTH_ID_KEY = "".concat(NAMESPACE, "/authId");
export var IDENTITY_TOKEN_CONNECTION_KEY = "".concat(NAMESPACE, "/connection");
export var RETURNURL_STORAGE_KEY = 'lendi_auth:return_url';
export var SAFETY_NET_COOKIE_NAME = 'safetynet';
export var LG_APP_AUTH_SESSION_COOKIE_NAME = 'authsession';
export var BYPASS_POSTCODE = 'bypass_postcode';
export var PRL_STORE_ID = 'prl_storeid';
export var PRL_BROKER_ID = 'prl_brokerid';
export var CUSTOMER_REFERRAL_CODE = 'customer_refcode';
export var PRL_COMPANY_GEN = 'prl_company_gen';
export var PRL_CAMPAIGN_NAME = 'prl_campaign_name';
export var LOCAL_STORAGE_KEYS = {
    COTR_PROMPT_DATA: 'cotr_prompt_data',
};
export var SESSION_STORAGE_KEYS = {
    CTOR_TARGET_STORE_ID: 'target-storeid',
    CTOR_TARGET_BROKER_ID: 'target-brokerid',
    CTOR_REQUESTED_STORE_ID: 'requested-storeid',
    CTOR_REQUESTED_BROKER_ID: 'requested-brokerid',
};
//# sourceMappingURL=consts.js.map